function setCookie(name, value, days) {
  let expires = "";
  if (days) {
    let date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = "; expires=" + date.toUTCString();
  }
  document.cookie = name + "=" + (value || "") + expires + "; path=/";
}

// Function to get a cookie by name
function getCookie(name) {
  let nameEQ = name + "=";
  let ca = document.cookie.split(";");
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === " ") c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
}

function globalPopup() {
  const globalPopup = document.querySelector(".global-popup");

  if (!globalPopup) return;

  const closeButton = document.querySelector("#close-global-popup");
  const alert = document.querySelector(".sitewide-alert");

  let popupID = 1;

  if (alert) {
    popupID = alert.getAttribute("data-uuid");
  }

  function checkPopup() {
    if (getCookie("popup_id") != popupID) {
      globalPopup.style.display = "block";
    }
  }

  function closePopup() {
    globalPopup.style.display = "none";
    setCookie("popup_id", popupID, 30);
  }

  closeButton.addEventListener("click", closePopup);

  checkPopup();
}

window.addEventListener("load", () => {
  setTimeout(() => {
    globalPopup();
  }, 2000);
});
